exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapsed>.when-open,.not-collapsed>.when-closed{display:none}.flex-parent{display:flex}.long-and-truncated{flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.long-and-truncated img{max-width:25px}", ""]);

// exports
